import React, { useState } from 'react';
import { signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../firebase';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [mode, setMode] = useState('login');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError('Invalid email or password. Please try again.');
      setLoading(false);
    }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await sendPasswordResetEmail(auth, email);
      setResetSent(true);
      setLoading(false);
    } catch (err) {
      setError('Email not found. Please contact ARCHX AI.');
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <img src="/logo.png" alt="ARCHX AI" style={{width:'260px', marginBottom:'8px'}} />
          <div className="login-tagline" style={{color:'rgba(255,255,255,0.25)', fontSize:'10px', letterSpacing:'0.12em'}}>Case Submission Portal</div>
        </div>

        {mode === 'login' ? (
          <form onSubmit={handleLogin}>
            {error && <div className="login-error">{error}</div>}
            <label className="login-label">Email</label>
            <input className="login-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@practice.com" required />
            <label className="login-label">Password</label>
            <input className="login-input" type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="••••••••••" required />
            <button className="login-btn" type="submit" disabled={loading}>{loading ? 'Signing in...' : 'Sign in'}</button>
            <div className="login-forgot">
              <span style={{cursor:'pointer', color:'rgba(200,146,42,0.7)'}} onClick={() => { setMode('reset'); setError(''); }}>Forgot password?</span>
            </div>
          </form>
        ) : resetSent ? (
          <div style={{textAlign:'center'}}>
            <div style={{color:'#81c784', fontSize:'14px', marginBottom:'16px'}}>✓ Reset link sent to {email}</div>
            <div style={{color:'rgba(255,255,255,0.4)', fontSize:'12px', marginBottom:'20px'}}>Check your inbox and follow the link to reset your password.</div>
            <button className="login-btn" onClick={() => { setMode('login'); setResetSent(false); }}>Back to sign in</button>
          </div>
        ) : (
          <form onSubmit={handleReset}>
            <div style={{color:'rgba(255,255,255,0.6)', fontSize:'13px', marginBottom:'16px'}}>Enter your email and we'll send you a reset link.</div>
            {error && <div className="login-error">{error}</div>}
            <label className="login-label">Email</label>
            <input className="login-input" type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="you@practice.com" required />
            <button className="login-btn" type="submit" disabled={loading}>{loading ? 'Sending...' : 'Send reset link'}</button>
            <div className="login-forgot">
              <span style={{cursor:'pointer', color:'rgba(200,146,42,0.7)'}} onClick={() => { setMode('login'); setError(''); }}>Back to sign in</span>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
